var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"parent",staticClass:"activechecker",attrs:{"data-active":_vm.active ? 'true' : 'false'}},[_c('div',{staticClass:"activechecker__content"},[_c('span',{domProps:{"textContent":_vm._s(_vm.active ? 'Active' : 'Inactive')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }